export const CONTACT_NOT_FOUND_EXCEPTION = 'ContactNotFoundException';

export const DEFAULT_ERROR_MSG = 'Sorry, that action failed. Please try again.';

export const AGENT_TASK_TRANSFER_FAILURE =
  'Something went wrong transferring to this agent or queue. Please try again or try transferring to somewhere else.';
